import { gql } from '@apollo/client';

export default gql`
  mutation UpdateCompetitionSeasonPriority(
    $input: updateCompetitionSeasonInput!
  ) {
    updateCompetitionSeasonPriority(input: $input) {
      id
    }
  }
`;
